import { LOCALE } from '@wix/wix-chatbot-common/locale';

import { IGenerateAnswerState } from '../../common/reducers/types';
import { locale } from '../constants';
import { cleanGeneratedAnswer, countWords } from './index';

export const getSummarizedAnswersGenFieldsBi = (answerGenResult: IGenerateAnswerState) => {
  if (locale !== LOCALE.EN) {
    return {
      summarizedAnswerBasedOn: undefined,
      summarizedAnswerType: undefined,
      summarizedAnswerText: undefined,
      summarizedAnswerWordsCount: undefined,
    };
  }

  let summarizedAnswerType;
  if (answerGenResult.prohibited) {
    summarizedAnswerType = 'prohibited';
  }
  if (answerGenResult.error || !answerGenResult.answer || answerGenResult.answer.length === 0) {
    summarizedAnswerType = 'answer generation failed';
  }
  if (answerGenResult.answer) {
    summarizedAnswerType = 'list';
  }

  const getSummarizedAnswerBasedOn = () => {
    if (answerGenResult.usedArticlesInfo) {
      return answerGenResult.usedArticlesInfo.map((usedArticle) => usedArticle.name).join(', ');
    }
    return answerGenResult.usedArticles?.join(', ') || '';
  };

  return {
    summarizedAnswerBasedOn: getSummarizedAnswerBasedOn(),
    summarizedAnswerType,
    summarizedAnswerText: answerGenResult.answer ? cleanGeneratedAnswer(answerGenResult.answer) : undefined,
    summarizedAnswerWordsCount: countWords(answerGenResult.answer || ''),
  };
};
